import { toCents, fromCents, addCents } from './paymentMoney.mjs';

export function operationPaymentCents(operation, side) {
    if (!['customer', 'provider'].includes(side)) throw new Error('Invalid payment direction.');
    const customer = side === 'customer';
    const temporary = operation[customer ? 'tmpCustomerAmount' : 'tmpProviderAmount'];
    if (temporary && temporary !== 0) return toCents(temporary);
    const links = operation[customer ? 'payments_from_customer' : 'payments_to_provider'] || [];
    const paid = links.reduce((sum, payment) => addCents(sum, toCents(payment.amount)), 0);
    const base = toCents(customer ? operation.sale_price : operation.cost_total);
    return addCents(customer ? base : -base, -paid);
}

export function paymentPayload(operations, side) {
    return operations.map(operation => ({
        _id: operation._id,
        __v: operation.__v,
        amount: fromCents(operationPaymentCents(operation, side)),
        ...(side === 'provider' ? { reference: operation.ticket_number } : {}),
    }));
}

export function selectedPaymentTotals(operations) {
    let customer = 0, provider = 0;
    for (const operation of operations) {
        customer = addCents(customer, operationPaymentCents(operation, 'customer'));
        provider = addCents(provider, operationPaymentCents(operation, 'provider'));
    }
    return { sale_price: fromCents(customer), cost_total: fromCents(-provider) };
}
